export function completesByNotes(notes: string) {
    return notes.split(',')
        .map(stringPart => stringPart.split(' '))
        .flat()
        .filter(stringPart => !!stringPart)
        .length;
}
